//fake enum for body part IDs
export const BPID = {
    HEAD: "head",
    EYES: "eyes",
    EYEBROW_LEFT: "eyebrow_left",
    EYEBROW_RIGHT: "eyebrow_right",
    SNOUT: "snout",
    NOSE: "nose",
    MOUTH: "mouth",
    EAR_LEFT: "ear_left",
    EAR_RIGHT: "ear_right",
    ANTENNA: "antenna",
    MIDDLE: "middle",
    ARM_LEFT: "arm_left",
    ARM_RIGHT: "arm_right",
    LEG_LEFT: "leg_left",
    LEG_RIGHT: "leg_right",
    FOOT_LEFT: "foot_left",
    FOOT_RIGHT: "foot_right",
    WHISKERS: "whiskers",
    HEAD_FUZZ: "head_fuzz",
    HEAD_WRINKLES: "head_wrinkles",
    BODY_WRINKLES: "body_wrinkles",
    TAIL: "tail"
}